export const authSessionQueryKey = ["auth", "session"] as const;
